import { Mail, Linkedin, Copyright } from "lucide-react";
import { Link } from "react-router-dom";
import { GoogleAIFundBadge } from "@/components/ui/GoogleAIFundBadge";

export function Footer() {
  return <footer className="bg-primary py-12 px-6 mt-auto">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-white/90">
          {/* Company Info */}
          <div className="space-y-4">
            <h2 className="text-title font-semantic-semibold text-white">Get Careerfy Now</h2>
            <p className="text-body text-white/80 max-w-xs">
              Empowering job seekers with AI-powered interview preparation and career guidance.
            </p>
            <div className="pt-2">
              <GoogleAIFundBadge variant="compact" />
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-title font-semantic-semibold text-white">Quick Links</h3>
            <nav className="space-y-2">
              <Link to="/" className="block text-body hover:text-secondary transition-colors">
                Home
              </Link>
              <Link to="/interview" className="block text-body hover:text-secondary transition-colors">
                Practice Interview
              </Link>
              <Link to="/resume-builder" className="block text-body hover:text-secondary transition-colors">
                Resume Builder
              </Link>
            </nav>
          </div>

          {/* Resources */}
          <div className="space-y-4">
            <h3 className="text-title font-semantic-semibold text-white">Resources</h3>
            <nav className="space-y-2">
              <Link to="/faq" className="block text-body hover:text-secondary transition-colors">
                FAQ
              </Link>
              <Link to="/affiliate/register" className="block text-body hover:text-secondary transition-colors">
                Affiliate Program
              </Link>
              <Link to="/privacy-policy" className="block text-body hover:text-secondary transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms-and-conditions" className="block text-body hover:text-secondary transition-colors">
                Terms & Conditions
              </Link>
              <Link to="/refund-policy" className="block text-body hover:text-secondary transition-colors">
                Refund Policy
              </Link>
            </nav>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h3 className="text-title font-semantic-semibold text-white">Contact Us</h3>
            <div className="space-y-2">
              <a href="mailto:Info@careerfy.ai" className="flex items-center gap-2 text-body hover:text-secondary transition-colors">
                <Mail className="h-4 w-4" />
                <span>hello@careerfy.ai</span>
              </a>
              <div className="flex items-center gap-4 pt-2">
              <a href="https://www.linkedin.com/company/careerfy-ai" target="_blank" rel="noopener noreferrer" aria-label="Visit our LinkedIn page" className="hover:text-secondary transition-colors">
                <Linkedin className="h-5 w-5" />
              </a>
              <a href="https://www.reddit.com/user/careerfy_ai/" target="_blank" rel="noopener noreferrer" aria-label="Visit our Reddit page" className="hover:text-secondary transition-colors">
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0zm5.01 4.744c.688 0 1.25.561 1.25 1.249a1.25 1.25 0 0 1-2.498.056l-2.597-.547-.8 3.747c1.824.07 3.48.632 4.674 1.488.308-.309.73-.491 1.207-.491.968 0 1.754.786 1.754 1.754 0 .716-.435 1.333-1.01 1.614a3.111 3.111 0 0 1 .042.52c0 2.694-3.13 4.87-7.004 4.87-3.874 0-7.004-2.176-7.004-4.87 0-.183.015-.366.043-.534A1.748 1.748 0 0 1 4.028 12c0-.968.786-1.754 1.754-1.754.463 0 .898.196 1.207.49 1.207-.883 2.878-1.43 4.744-1.487l.885-4.182a.342.342 0 0 1 .14-.197.35.35 0 0 1 .238-.042l2.906.617a1.214 1.214 0 0 1 1.108-.701zM9.25 12C8.561 12 8 12.562 8 13.25c0 .687.561 1.248 1.25 1.248.687 0 1.248-.561 1.248-1.249 0-.688-.561-1.249-1.249-1.249zm5.5 0c-.687 0-1.248.561-1.248 1.25 0 .687.561 1.248 1.249 1.248.688 0 1.249-.561 1.249-1.249 0-.687-.562-1.249-1.25-1.249zm-5.466 3.99a.327.327 0 0 0-.231.094.33.33 0 0 0 0 .463c.842.842 2.484.913 2.961.913.477 0 2.105-.056 2.961-.913a.361.361 0 0 0 .029-.463.33.33 0 0 0-.464 0c-.547.533-1.684.73-2.512.73-.828 0-1.979-.196-2.512-.73a.326.326 0 0 0-.232-.095z"/>
                </svg>
              </a>
                <a href="https://www.instagram.com/careerfy.ai" target="_blank" rel="noopener noreferrer" aria-label="Visit our Instagram page" className="hover:text-secondary transition-colors">
                  <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-white/10 flex items-center justify-center text-body text-white/70 gap-2">
          <Copyright className="h-4 w-4" />
          <p>2024 Careerfy. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}